<template>
    <v-dialog v-model="d" width="60%" persistent>
        <v-card>
            <v-card-title>Manage Technician</v-card-title>
            <v-card-text>
                <v-text-field label="Name" v-model="active.name" color="primary" />
                <v-text-field label="Email" v-model="active.email" color="primary" />
                <v-text-field label="Region" v-model="active.region" color="primary" />
                <v-text-field label="Phone" v-model="active.phone" color="primary" />
                <v-text-field label="Order" v-model.number="active.order" color="primary" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="saveTechnician">Save Technician</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import {ValetHttp} from "../../http/ValetHttp";
    export default {
        name: "TechnicianModal",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            ...mapState("technicians", ["manageTechDialog", "activeTech"]),
            d: {
                get() {
                    return this.manageTechDialog;
                }
            },
            active: {
                get() {
                    return this.activeTech;
                }
            }
        },
        methods: {
            ...mapActions("technicians", ["setActiveTechnician", "setManageTechnicianDialog", "setTechnicians"]),
            ...mapMutations("app", ["setToast"]),
            async saveTechnician() {
                try {
                    this.isLoading = true;
                    if (!this.active._id) {
                        await ValetHttp.createNewTechnician(this.active);
                    } else {
                        await ValetHttp.updateTechnician(this.active);
                    }
                    this.setToast({color: 'success', text: 'Technician saved successfully', show: true});
                    await this.setTechnicians();
                    await this.setActiveTechnician({});
                    await this.setManageTechnicianDialog(false);
                } catch (err) {
                    this.setToast({color: 'error', text: err.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            },
            async closeDialog() {
                await this.setActiveTechnician({});
                await this.setManageTechnicianDialog(false);
            }
        }
    }
</script>

<style scoped>

</style>
